import { ActivitySaleType } from './form-type';

export function totalActivityRescheduleCalculation(
  activitySales: ActivitySaleType[],
) {
  const total = activitySales.reduce((prev, curr) => {
    //addons
    const addons = curr.activitySaleAddOns
      .filter((addons) => addons.isSelected)
      .reduce((prevAddOns, currAddOns) => prevAddOns + currAddOns.price, 0);

    //guest
    const guests = curr.activitySaleGuests
      .filter((guest) => guest.isSelected)
      .reduce((prevGuest, currGuest) => {
        //activity
        const activities = currGuest.activitySaleGuestDetails
          .filter((detail) => detail.isSelected)
          .reduce(
            (prevDetail, currDetail) => prevDetail + currDetail.totalPrice,
            0,
          );
        return prevGuest + activities;
      }, 0);

    return prev + addons + guests;
  }, 0);

  return total;
}
